module.exports = __webpack_public_path__ + "static/img/15.97fa27a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/eng/15.png
// module id = Foit
// module chunks = 0